import React from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo.svg"; // Adjust if your logo is elsewhere
import "./TitleScreen.css";
import img from "../images/title.png"; // Adjust the path to your background image

const TitleScreen = () => {
  return (
    <div className="title-container">
      <img src={logo} alt="Senu Logo" className="title-logo" />

      <h1 className="title-heading">Welcome to Senu App</h1>
      <p className="title-subtitle">Eyes in the Sky, Guardians on the Ground</p>
      <img src={img} alt="Senu Img" className="title-image" />

      <Link to="/login" className="title-button">
        Get Started
      </Link>
    </div>
  );
};

export default TitleScreen;
